import * as types from "../actions/actionTypes";

const initialState = {
  projects: [],
  companyProjects: [],
  project: null,
  searchData: [],
  searchLoading: false,
};

const projects = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALL_PROJECTS_RESPONSE: return { ...state, projects: action.payload };
    case types.GET_PROJECT_BY_ID_RESPONSE: return { ...state, project: action.payload };
    case types.GET_PROJECT_BY_COMPANY_ID_RESPONSE: return { ...state, companyProjects: action.payload };

    case types.GET_SEARCH_DATA:
      return { ...state, searchLoading: true };
    case types.GET_SEARCH_DATA_RESPONSE:
      return { ...state, searchData: action.payload, searchLoading: false };
    case types.CLEAR_SEARCH_DATA:
      return { ...state, searchData: [], searchLoading: false };

    case types.CREATE_PROJECT: return { ...state, project: null };
    case types.UPDATE_PROJECT: return { ...state, project: null };
    case types.DELETE_PROJECT: return { ...state, project: null };
    default:
      return state;
  }
};

export default projects;
